import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { StepsProps } from './types';
import ArrowIcon from 'assets/images/arrowicon.png';
import './Steps.scss';

export const Steps: React.FC<StepsProps> = ({
  steps,
  baseLink,
  activeStep,
  allowAllStepsClickable,
  enableNavigatingPreviousSteps,
}) => {
  const itemRefs = useRef<any>([]);
  const isStepDisabled = (index: number) => {
    if (allowAllStepsClickable) {
      return false;
    } else if (enableNavigatingPreviousSteps && activeStep > 0) {
      return index + 1 > activeStep;
    }

    return index + 1 !== activeStep;
  };

  useEffect(() => {
    if (!Number.isNaN(activeStep)) {
      itemRefs.current[activeStep - 1].scrollIntoView();
    }
  }, [activeStep]);

  return (
    <div className="steps table-responsive">
      <ul className="nav mb-2 flex-nowrap">
        {steps.map((step, index: number) => (
          <li
            className="nav-item d-inline-flex align-items-center"
            key={step}
            ref={(el) => (itemRefs.current[index] = el)}
            style={{
              pointerEvents: isStepDisabled(index) ? 'none' : 'auto',
            }}
          >
            <Link
              className={`nav-link ${activeStep - 1 === index ? 'active' : ''}`}
              to={`${baseLink}/${index + 1}`}
            >
              <span className="step-number">{index + 1}</span>
              <p className="mb-0">{step}</p>
            </Link>
            <img alt="" src={ArrowIcon} />
          </li>
        ))}
      </ul>
    </div>
  );
};
